import api from './api';

// Kept out of lib/api.js deliberately, same posture as
// adminWiseSupplierTraceApi.js/adminReceiptPaidTraceApi.js: this is the
// only call site this card needs, and lib/api/*.js domain files are edited
// concurrently by other sessions. Reuses api's shared axios instance
// (baseURL, auth interceptor) unchanged.
//
// Out-of-band (202 + job id, JobStore-backed -- same shape as the
// Wise Supplier trace card). No params: the census always runs against the
// current full Wise Supplier cohort, never a single transaction.
export const adminWiseSupplierAccrecCensusAPI = {
  start: () => api.post('/admin/diagnostics/wise-supplier-accrec-census/start'),
  jobStatus: (jobId) => api.get(`/admin/diagnostics/wise-supplier-accrec-census/job-status/${jobId}`),
  jobLatest: () => api.get('/admin/diagnostics/wise-supplier-accrec-census/job-latest'),
};
